import { Injectable, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Constants } from '../constants/constants.service';
import { DataService } from '../utils/data/data.service';
import { Session } from '../session/session.service';

@Injectable()
export class GruposCuentasService implements OnInit
{
    constructor(
      private http: HttpClient,
      private session: Session,
      private dataService: DataService
    ){
    }

    ngOnInit(){}
    lista(datos, callback){
      var formData: FormData;
      formData = new FormData();

      this.http
      .post(
        Constants.API_BASE + "/gruposcuentas/listar",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    listaPorAPR(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/gruposcuentas/listarPorAPR",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    crear(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/gruposcuentas/crear",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    editar(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/gruposcuentas/editar",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    crearRegion(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/regiones/crearRegion",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }

    editarRegion(datos, callback){
      var formData: FormData;
      formData = this.dataService.createFormData(datos);
      formData.append('accessToken', this.session.currentUser.accessToken);

      this.http
      .post(
        Constants.API_BASE + "/regiones/editarRegion",
        formData,
        { withCredentials: true }
      )
      .subscribe(data => {
        callback(data);
      });
    }
}



// WEBPACK FOOTER //
// ./src/app/services/gruposcuentas/gruposcuentas.service.ts